import React from 'react';
import {
  Paper,
  Tabs,
  Tab,
} from '@mui/material';
import { FormattedMessage } from 'react-intl';

type Props = {
  onTabChange: (tabId: 'institute'|'individual') => void;
  selectedTab: 'institute'|'individual';
};

const TrialTypeTabs: React.FC<Props> = ({
  onTabChange,
  selectedTab,
}: Props) => {
  const onChangeTab = (event: React.ChangeEvent<unknown>, newValue: 'institute'|'individual') => {
    onTabChange(newValue);
  };

  return (
    <Paper square elevation={0}>
      <Tabs
        value={selectedTab}
        indicatorColor="secondary"
        textColor="primary"
        onChange={onChangeTab}
        variant="scrollable"
        scrollButtons="auto"
      >
        <Tab label={<FormattedMessage id="trialsTablabel.institute" />} value="institute" />
        <Tab label={<FormattedMessage id="trialsTablabel.individual" />} value="individual" />
      </Tabs>
    </Paper>
  );
};

export default TrialTypeTabs;
